/**
 * Switches for UI.
 * Flip to `true` to bring the behaviour back.
 */

/** Auto-process-on-confidence toggle and its dependent "Notify me" toggle, on ManualUpload. */
export const SHOW_AUTO_PROCESS_CONTROLS = false;

/** Retention policy details and the lifecycle timeline, on ManualUpload and RecordDetails. */
export const SHOW_RETENTION_AND_DISPOSAL = false;
